import React from 'react';
import View from 'views/Hour/Index'
import HourAction from '../../actions/HourAction';
import BaseContainer, { selector } from 'containers/BaseContainer';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n';
import moment from 'moment'
/**
 * Files are automatically generated from the template.
 * MQ Solutions 2019
 */
class Index extends BaseContainer {
    constructor(props) {
        super(props)
        this.refTable = null
        this.onFetchData = this.onFetchData.bind(this)
        this.onRefTable = this.onRefTable.bind(this)
        this.state = {
            currentPage: 0,
            pageSize: 20,
            filters: [],
            sorting: []
        }
        this.query = {
            startDate: moment().startOf('month').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD')
        }
        this.storePrintData();
    }
    storePrintData() {
        let { startDate, endDate } = this.query;
        startDate = moment(startDate).format('YYYY/MM/DD');
        endDate = moment(endDate).format('YYYY/MM/DD')
        localStorage.setItem("print_hours", JSON.stringify({startDate, endDate}));
    }
    componentDidUpdate(prevProps) {
    }   
    componentDidMount() {
        this.onFetchData()
    }
    onRefTable(ref) {
        this.refTable = ref
    }
    onSubmitDate = async (dateRange) => {
        this.query = {
            startDate: moment(dateRange.startDate).format('YYYY-MM-DD'),
            endDate: moment(dateRange.endDate).format('YYYY-MM-DD')
        }
        this.storePrintData()
        this.onFetchData()
    }
    get is60Time() {
        let { data } = this.props;
        return data && data.is60Time
    }
    onFetchData(state = {}) {
        let { currentPage, pageSize, filters, sorting } = state
        currentPage = currentPage !== undefined ? currentPage : this.state.currentPage
        pageSize = pageSize !== undefined ? pageSize : this.state.pageSize
        filters = filters !== undefined ? filters : this.state.filters
        sorting = sorting !== undefined ? sorting : this.state.sorting
        this.setState({ currentPage, pageSize, filters, sorting })

        this.props.dispatch(HourAction.fetchAllUserTimekeeping({
            ...this.query,
            currentPage: currentPage,
            pageSize: -1,
            filters: filters,
            sorting: sorting
        }))
    }
    render() {
        return (
            <View
                onFetchData={this.onFetchData}
                onRefTable={this.onRefTable}
                data={this.props.data}
                onSubmitDate={this.onSubmitDate}
                is60Time={this.is60Time}
            />
        )
    }
}
const mapStateToProps = state => {
    return {
        data: selector(state, "hour.list", {}),
    }
}
export default withRouter(connect(mapStateToProps)(Index))
